const userLogin = (userData) => ({
    type: "USER_LOGIN",
    payload: userData
});

const userLogout = (userData) => ({
    type: "USER_LOGOUT"
});

const userLoad = () => ({
    type: "USER_LOAD"
});

const updateUserSettings = (userSettings) => ({
    type: "UPDATE_USER_SETTINGS",
    payload: userSettings
});

export { userLogin, userLogout, userLoad, updateUserSettings };